










import Vue from "vue";

export default Vue.extend({
  name: "DBMenu",
  //   props: {
  //     msg: String,
  //   },
});
